import React from "react";
import styles from "../styles/styles";
import { getCategoryColor } from "../util/categoryColor";

export default function DerailmentMatrix({
    cars = [],
    categoryLabel = "Descarrilamento",
    rows = [],
    matrixData = {}
}) {

    return (
        <div style={styles.derailmentWrapper}>

            <table style={styles.pantographTable}>

                <thead>
                    <tr>
                        <th style={{ width: "40px" }}></th>
                        <th style={{ width: "180px" }}></th>
                    </tr>
                </thead>

                <tbody>

                    {rows.map((row, rowIndex) => (

                        <tr key={rowIndex}>

                            {rowIndex === 0 && (
                                <td
                                    rowSpan={rows.length}
                                    style={styles.derailmentVertical}
                                >
                                    {categoryLabel}
                                </td>
                            )}

                            <td
                                style={{
                                    ...styles.derailmentLabel,
                                    borderTop:
                                        rowIndex === 0
                                            ? "1px solid #9ca3af"
                                            : "none",

                                    borderBottom:
                                        rowIndex === rows.length - 1
                                            ? "1px solid #9ca3af"
                                            : "none"
                                }}
                            >
                                {row.label}
                            </td>

                            {cars.map(car => {

                                const activeIndexes =
                                    matrixData?.[car]?.[row.key] ?? [];

                                const categories =
                                    matrixData?.[car]?.[
                                    `${row.key}Category`
                                    ] ?? {};

                                return (

                                    <td
                                        key={car}
                                        style={styles.derailmentCell}
                                    >

                                        <SquareGroup
                                            activeIndexes={activeIndexes}
                                            categories={categories}
                                        />

                                    </td>
                                );
                            })}

                        </tr>
                    ))}

                </tbody>

            </table>

        </div>
    );
}

function SquareGroup({
    activeIndexes = [],
    categories = {}
}) {

    return (

        <div style={styles.derailmentSquareGroup}>

            {Array.from({ length: 4 }).map((_, i) => (

                <div
                    key={i}

                    style={{
                        ...styles.derailmentSquare,

                        background:
                            activeIndexes.includes(i)
                                ? (
                                    getCategoryColor(
                                        categories[i]
                                    ) || "#ef4444"
                                )
                                : "#ffffff",

                        color:
                            activeIndexes.includes(i)
                                ? "#ffffff"
                                : "#000000"
                    }}
                />

            ))}

        </div>
    );
}